// extracted by mini-css-extract-plugin
export var optionGrid = "_72-7";
export var optionList = "_72-6";
export var questionsBlock = "_72-9";
export var spacer = "_72-5";
export var stepCenteredContent = "_72-3";
export var stepInner = "_72-0";
export var stepInnerFullWidth = "_72-1";
export var stepInnerLockScroll = "_72-2";
export var stepTransitionFrame = "_72-4";
export var welcomeBlock = "_72-8";